import { createLabeledMessages } from '../../../messageUtils';
const person = {
    firstName: 'meno',
    surname: 'priezvisko',
    birthNumber: 'rodné číslo',
    birthNumber_short: 'RČ',
    birthDate: 'dátum narodenia',
    ico: 'IČO',
    type: 'typ osoby',
    degreeBefore: 'titul pred',
    degreeAfter: 'titul za',
    phone: 'pevná linka',
    mobile: 'mobilný telefón',
    email: 'e-mail',
    logon: 'prihlasovacie meno',
    foreigner: 'cudzinec',
    nationality: 'štátna príslušnosť',
    count: 'počet osôb'
};
export default Object.assign({}, person, createLabeledMessages(person));
